// extracted by mini-css-extract-plugin
export default {"btn":"cookieConsentir_btn__JU4yH","p":"cookieConsentir_p__-6h9i","Link":"cookieConsentir_Link__i9Qh2"};